import React, {useState} from 'react'

// material
import { Button, Card, CardContent, Grid, TextField, withStyles} from '@material-ui/core';
import { Facebook, LinkedIn, Twitter, Instagram } from '@material-ui/icons';
// styles
import styles from './social-media-card-styles';

const SocialMediaCardEdit = (props)=> {
  const {
    classes,
    isLoading,
    socialMedia
  } = props;

  const [facebook, setFacebook] = useState(socialMedia.facebookProfileUrl === null ? '' : socialMedia.facebookProfileUrl);
  const [linkedIn, setLinkedIn] = useState(socialMedia.linkedInProfileUrl === null ? '' : socialMedia.linkedInProfileUrl);
  const [twitter, setTwitter] = useState(socialMedia.twitterProfileUrl === null ? '' : socialMedia.twitterProfileUrl);
  const [instagram, setInstagram] = useState(socialMedia.instagramProfileUrl === null ? '' : socialMedia.instagramProfileUrl);

  const submitNewUserSocialMedia = () => {
    const newsocialMedia = socialMedia;
    newsocialMedia.facebookProfileUrl = facebook;
    newsocialMedia.linkedInProfileUrl = linkedIn;
    newsocialMedia.twitterProfileUrl = twitter;
    newsocialMedia.instagramProfileUrl = instagram;
    props.setUserSocialMedia(newsocialMedia);
  };

  return(
    <Card>
      <CardContent>
        <Grid container className={classes.displayTitle} spacing={2}>
          <Grid item>Social Media</Grid>
        </Grid>
        {
          !isLoading &&
          <Grid container className={classes.displayBody} spacing={2}>
            <Grid item xs={12} sm={12}>
              <Grid container alignItems="center" spacing={2}>
                <Grid item>
                  <Facebook fontSize={'large'}/>
                </Grid>
                <Grid item xs={12} sm={10}>
                  <TextField
                    fullWidth
                    label={'Facebook'}
                    value={facebook}
                    name={'Facebook'}
                    onChange={e => setFacebook(e.target.value)}
                    variant={'outlined'}/>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid container alignItems="center" spacing={2}>
                <Grid item>
                  <LinkedIn fontSize={'large'}/>
                </Grid>
                <Grid item xs={12} sm={10}>
                  <TextField
                    fullWidth
                    label={'LinkedIn'}
                    value={linkedIn}
                    name={'LinkedIn'}
                    onChange={e => setLinkedIn(e.target.value)}
                    variant={'outlined'}/>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid container alignItems="center" spacing={2}>
                <Grid item>
                  <Twitter fontSize={'large'}/>
                </Grid>
                <Grid item xs={12} sm={10}>
                  <TextField
                    fullWidth
                    label={'Twitter'}
                    value={twitter}
                    name={'Twitter'}
                    onChange={e => setTwitter(e.target.value)}
                    variant={'outlined'}/>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid container alignItems="center" spacing={2}>
                <Grid item>
                  <Instagram fontSize={'large'}/>
                </Grid>
                <Grid item xs={12} sm={10}>
                  <TextField
                    fullWidth
                    label={'Instagram'}
                    value={instagram}
                    name={'Instagram'}
                    onChange={e => setInstagram(e.target.value)}
                    variant={'outlined'}/>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid container spacing={2}>
                <Grid item>
                  <Button color={'primary'} size={'small'} variant={'contained'} onClick={() => submitNewUserSocialMedia()}>Save</Button>
                </Grid>
                <Grid item>
                  <Button color={'primary'} size={'small'} onClick={() => props.toggleEdit()}>Cancel</Button>
                </Grid>
              </Grid>   
            </Grid>
          </Grid>
        }
      </CardContent>
    </Card>
  )
};

export default withStyles(styles) (SocialMediaCardEdit);